import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'features/store';

export type MenuState = {
    itemSelected: number;
};

const initialMenuState = {
    itemSelected: 0
};

export const menuSlice = createSlice({
    name: 'menu',
    initialState: initialMenuState,
    reducers: {
        setAdminItemSelected: (state, data) => {
            const { itemSelected } = data.payload;
            state.itemSelected = itemSelected;
        },
        setUserItemSelected: (state, data) => {
            const { itemSelected } = data.payload;
            state.itemSelected = itemSelected;
        },
        reset: (state) => {
            state.itemSelected = 0;
        }
    }
});
export const getItemSelected = (state: RootState) => state.menu.itemSelected;
export const { setAdminItemSelected, setUserItemSelected, reset } = menuSlice.actions;

export default menuSlice.reducer;
